import type { PayorRow } from "../types";

interface PayorAcceptanceBoardProps {
  rows: PayorRow[];
  /** Cycles Accept → Review → Decline. */
  onCyclePolicy: (row: PayorRow) => void;
}

/**
 * Payor acceptance board — counts only, built from Referrals and Non-Admits
 * with the payor filter. No rates, no scores: the point is a policy decision
 * per payor, and the counts are there to justify it.
 */
export function PayorAcceptanceBoard({ rows, onCyclePolicy }: PayorAcceptanceBoardProps) {
  return (
    <section className="card">
      <div className="lbl">
        Payor acceptance board <span className="n">last 30 days · tap policy to change</span>
      </div>
      <table>
        <thead>
          <tr>
            <th>Payor</th>
            <th className="num">Referred</th>
            <th className="num">Accepted</th>
            <th className="num">Declined</th>
            <th>Policy</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.payor}>
              <td>{r.payor}</td>
              <td className="num">{r.referred}</td>
              <td className="num good">{r.accepted}</td>
              {/* 10+ declines in 30 days is the point where a payor policy is
                  worth a second look, so the number stops being neutral. */}
              <td className={"num" + (r.declined >= 10 ? " bad" : "")}>{r.declined}</td>
              <td>
                <button className={"tag " + r.policy.toLowerCase()} onClick={() => onCyclePolicy(r)}>
                  {r.policy}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="note">
        Counts only — built from Referrals and Non-Admits with the payor filter. Policy changes are audit-logged.
      </div>
    </section>
  );
}
